export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/plumbing-68910daa365a9755ba6295d12488221b.svg";